import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { usePlausible } from 'next-plausible';
import { useState } from 'react';
import LoginButton from '../../Header/LoginButton';
import DomainAvailability from './DomainAvailability';
import TfAvailability from './TfAvailability';
import HiveAvailability from './HiveAvailability';
import getSlug from 'speakingurl';

export default function BlogNameDialog({ open, setOpen, name }) {
  const [signUpOpen, setSignUpOpen] = useState(false);
  const plausible = usePlausible();
  const domainName = name ? getSlug(name).replace(/-/g, '') : '';

  const handleClaim = () => {
    plausible('CTA: Claim Name');
    // /join/setup prefills the username field from this key, so the name
    // survives the email-OTP / OAuth hop into the signup funnel. The
    // timestamp lets setup expire abandoned claims instead of resurfacing
    // them on an unrelated later signup.
    try {
      window.localStorage.setItem(
        'tf_claimed_name',
        JSON.stringify({ name: domainName, ts: Date.now() }),
      );
    } catch {
      // localStorage unavailable (private mode) — the funnel still works
    }
    setSignUpOpen(true);
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">Claim @{domainName}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Start your travel blog with TravelFeed!
          </DialogContentText>
          <DomainAvailability domainName={`${domainName}.com`} />
          <TfAvailability username={domainName.substring(0, 16)} />
          <HiveAvailability username={domainName.substring(0, 16)} />
          {/* <NameAvailability platform=".com" />
          <NameAvailability platform="instagram" />
          <NameAvailability platform="travelfeed" /> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Close
          </Button>
          <Button variant="contained" color="primary" onClick={handleClaim}>
            Start Your Travel Blog
          </Button>
        </DialogActions>
      </Dialog>
      {signUpOpen && (
        <LoginButton
          open={signUpOpen}
          hideButtons
          onClickClose={() => setSignUpOpen(false)}
          text={` and claim ${domainName}`}
          usernameToCreate={domainName}
        />
      )}
    </>
  );
}
